
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Secret() {
    const [password, setPassword] = useState('');
    const [unlocked, setUnlocked] = useState(false);

    const SECRET = 'iLoveMyPookie';

    const handleSubmit = e => {
        e.preventDefault();
        if (password === SECRET) {
            setUnlocked(true);
        } else {
            alert('Incorrect password.');
        }
    };

    return (
        <section className={unlocked ? 'secret-page' : 'secret-login'}>
            {!unlocked ? (
                <form onSubmit={handleSubmit}>
                    <label>
                        Enter password:{' '}
                        <input
                            type="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            autoFocus
                        />
                    </label>
                    <button type="submit">Unlock</button>
                </form>
            ) : (
                <>
                    <h2>Hi Pookie</h2>
                    <p>Love you</p>
                </>
            )}

            {/* Always show a Home button at the bottom */}
            <Link to="/" className="secret-home">
                ← Home
            </Link>
        </section>
    );
}
